<section class="politica-section">
  <div class="politica-container">

    <h2>Política de Privacidade</h2>

    <p class="data">
      Data de disponibilização: 07/07/2025
    </p>

    <p>
      Na CuidaZap, temos o compromisso com a privacidade e a segurança dos dados
      pessoais de todos os nossos usuários. Por isso, esta Política de Privacidade
      foi elaborada para informar, de maneira clara e transparente, como tratamos
      os dados pessoais, em conformidade com a Lei Geral de Proteção de Dados
      Pessoais (LGPD – Lei nº 13.709/2018).
    </p>

    <p>
      Este documento descreve como coletamos, utilizamos, armazenamos e protegemos
      os seus dados pessoais ao utilizar nossos serviços, incluindo nosso site,
      aplicativos, sistemas de comunicação e assistência via WhatsApp.
    </p>

    <p>
      Caso tenha qualquer dúvida, sugestão ou reclamação, entre em contato conosco
      pelo e-mail
      <strong>contato@cuidazap.com</strong>.
    </p>

    <h3>DEFINIÇÕES IMPORTANTES</h3>

    <p>
      <strong>Usuário:</strong> Pessoa física que utiliza os serviços do CuidaZap,
      seja idoso, familiar, cuidador ou representante legal.
    </p>

    <p>
      <strong>Controlador:</strong> Controlador é a pessoa física ou jurídica
      responsável pelas decisões referentes ao tratamento dos dados pessoais.
    </p>

    <p>
      <strong>Dados Pessoais:</strong> Qualquer informação relacionada a uma pessoa
      natural identificada ou identificável, como nome, telefone, endereço, data
      de nascimento, informações de saúde, entre outros.
    </p>

    <p>
      <strong>Dados Sensíveis:</strong> Dados relacionados à saúde, biometria,
      origem racial, convicções religiosas, opiniões políticas, entre outros,
      tratamento de Dados relacionados à saúde.
    </p>

    <h3>A QUEM ESTE AVISO SE APLICA</h3>

    <p>
      Este Aviso se aplica a todos os indivíduos que interajam com os serviços
      prestados pelo CuidaZap, incluindo, mas não se limitando a:
    </p>

    <ul>
      <li>Usuários idosos;</li>
      <li>Familiares ou responsáveis;</li>
      <li>Cuidadores e profissionais de saúde vinculados à plataforma.</li>
    </ul>

    <h3>QUAIS DADOS COLETAMOS?</h3>

    <p>Podemos coletar os seguintes dados pessoais:</p>

    <ul>
      <li>
        Dados de identificação, como nome, CPF, data de nascimento, e-mail,
        telefone, gênero;
      </li>

      <li>
        Dados de contato: endereço, número de WhatsApp, contato de emergência;
      </li>

      <li>
        Dados de saúde e informações sobre diagnósticos, alergias, histórico
        de sintomas;
      </li>

      <li>
        Dados de uso: interações via WhatsApp, registros de atendimento,
        assistência prestada;
      </li>

      <li>
        Dados técnicos: endereço IP, data e hora de acessos, cookies e
        informações de navegação.
      </li>
    </ul>

    <h3>COMO COLETAMOS OS DADOS?</h3>

    <p>Os dados podem ser coletados:</p>

    <ul>
      <li>
        Diretamente com o usuário no momento do cadastro ou durante interações
        pelo WhatsApp;
      </li>

      <li>
        Por meio de formulários ou dados fornecidos pelo usuário;
      </li>

      <li>
        A partir dos serviços ou parceiros autorizados;
      </li>

      <li>
        Por integrações com ferramentas de terceiros (ex.: calendários,
        ERPs de saúde).
      </li>
    </ul>

    <h3>FINALIDADE DO TRATAMENTO DE DADOS</h3>

    <p>Utilizamos seus dados pessoais para:</p>

    <ul>
      <li>Prestar assistência personalizada via WhatsApp;</li>
      <li>Enviar lembretes de medicação e consultas;</li>
      <li>Comunicar situações de urgência a familiares e contatos de emergência;</li>
      <li>Enviar pesquisas e sugestões de melhoria dos serviços;</li>
      <li>Cumprir obrigações legais e regulatórias.</li>
    </ul>

    <h3>BASE LEGAL PARA O TRATAMENTO</h3>

    <p>
      A CuidaZap trata seus dados com base:
    </p>

    <ul>
      <li>No consentimento do titular;</li>
      <li>
        Na execução de contrato ou procedimentos preliminares;
      </li>
      <li>
        No cumprimento de obrigação legal ou regulatória;
      </li>
      <li>
        No exercício regular de direitos;
      </li>
      <li>
        No legítimo interesse da CuidaZap, desde que respeitados os direitos
        do titular.
      </li>
    </ul>

    <h3>COMPARTILHAMENTO DE DADOS</h3>

    <p>
      Poderemos compartilhar dados com:
    </p>

    <ul>
      <li>
        Equipe interna de atendimento e tecnologia;
      </li>

      <li>
        Parceiros e prestadores de serviços necessários para operação da
        plataforma (ex.: hospedagem, envio de mensagens);
      </li>

      <li>
        Autoridades públicas, em cumprimento à legislação vigente;
      </li>

      <li>
        Familiares e cuidadores autorizados pelo usuário.
      </li>
    </ul>

    <h3>TRANSFERÊNCIA INTERNACIONAL DE DADOS</h3>

    <p>
      Alguns dados podem ser armazenados em servidores localizados fora do Brasil.
      Nesses casos, garantimos que os dados serão tratados de acordo com a LGPD
      e medidas de segurança compatíveis.
    </p>

    <h3>SEGURANÇA DOS DADOS</h3>

    <p>
      Adotamos medidas técnicas e administrativas adequadas para proteger seus
      dados contra acessos não autorizados, vazamentos, alterações ou destruições
      indevidas.
    </p>

    <h3>DIREITOS DOS TITULARES</h3>

    <p>
      Você tem direito a:
    </p>

    <ul>
      <li>Confirmar a existência do tratamento;</li>
      <li>Acessar seus dados;</li>
      <li>Corrigir dados incompletos ou desatualizados;</li>
      <li>
        Solicitar anonimização, bloqueio ou eliminação de dados desnecessários
        ou tratados em desconformidade;
      </li>
      <li>Solicitar a portabilidade dos dados;</li>
      <li>Revogar o consentimento;</li>
      <li>Opor-se ao tratamento.</li>
    </ul>

    <p>
      Para exercer seus direitos, entre em contato pelo e-mail
      <strong>contato@cuidazap.com</strong>.
    </p>

    <h3>TEMPO DE ARMAZENAMENTO</h3>

    <p>
      Os dados pessoais serão armazenados enquanto:
    </p>

    <ul>
      <li>Houver relação entre o usuário e o CuidaZap;</li>
      <li>Necessário para cumprir obrigações legais;</li>
      <li>
        Necessário para resguardar direitos em processos judiciais ou
        administrativos.
      </li>
    </ul>

    <h3>ALTERAÇÕES DESTE AVISO</h3>

    <p>
      Este Aviso pode ser atualizado a qualquer momento. A nova versão será
      publicada em nossos canais oficiais, com destaque para alterações relevantes.
      Recomendamos revisão periódica.
    </p>

    <h3>CONTATO</h3>

    <p>
      Para dúvidas ou solicitações relacionadas à privacidade de dados, entre
      em contato:
      <strong>E-mail: contato@cuidazap.com</strong>
    </p>

    <p class="final-destaque">
      Versão atual: 1.0 | Data de publicação: 07/07/2025
    </p>

  </div>
</section>
